// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tab-box-video {
    width: 100%;
}

.tab-box-video ul {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    margin-bottom: 4rem;
}

.tab-box-video ul li {
    list-style: none;
    /* font-weight: 500; */
    font-size: 18px;
    padding: 5px 0;
    margin: 0px 25px;
    color: #878395;
    cursor: pointer;
}

.tab-box-video ul li.active {
    border-top: 3px solid #6c2fbb;
    color: #6c2fbb;
}

.library {
    margin-top: 4rem;
}

.FF-scroll-modify {
    /*max-height: 720px;*/
    /*height: 100%;*/
    height: 66vh;
    overflow-x: hidden;
    overflow-y: scroll;
    margin-top: 20px;
}
.badge-box-container {
    text-align: center;
    cursor: pointer;
}

.add-box {
    aspect-ratio: 16/9;
    position: relative;
    width: 100%;
    min-height: 200px;
    height: 100%;
    border: 2px solid #6c2fbb;;
    border-radius: 16px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    cursor: pointer;
}

.add-box .plus {
    width: 28px;
    height: 26px;
    background: #F8FAFB;
    border-radius: 4px;
    text-align: center;
}

.add-box h5 {
    color: #6c2fbb;
}
.badgeAction {
    text-align: end;
    position: absolute;
    right: 15px;
    top: 0;
}

.badge-box .badge-rounded{
    z-index: 0 !important;
}

.popup-objective {
    z-index: 1;
    position: absolute;
    background: white;
    padding: 0 7px;
    border-radius: 6px;
    width: -moz-fit-content;
    width: fit-content;
    top: 30px;
    width: 200px;
    height: 210px;
    overflow: auto;
    left: -66px
}

.popup-objective ul {
    text-align: start;
    padding-left: 25px;
}

.popup-objective li {
    margin-top: 10px;
}

.custom-card {
    /* background-color: #fff; */
    width: 100%;
    height: auto;
    padding: 6px;
    /* box-shadow: 0px 0px 10px 0px #dad8d8; */
}

.custom-card .v-title-edit {
    display: flex;
}

.custom-card .v-title-edit .v-title-btn {
    cursor: pointer;
    margin: 0;
    display: none;
    padding-left: 5px;
}

.custom-card .v-title-edit:hover .v-title-btn {
    display: inline-block;
}
.v-title-edit:hover .v-title-btn {
    display: inline-block;
}

.custom-card .v-title {
    padding: 2px;
    cursor: text;
    font-weight: 500;
    font-size: 14px;
    color: #000;
}

.custom-card p {

    /*font-size: 16px;
    font-weight:400 !important;*/
    font-size: 15px;
    font-weight: 400;
    width: inherit;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    margin-top: 0;
    margin-bottom: 0;
    /*color: rgba(136, 133, 142, 1);*/
    color: #000;
}

::ng-deep .createBadgeModal{
    overflow: auto;
}


.downloadCer{
    background: #6c2fbbe3;
    font-size: 15px;
    color: #ffffff;
    padding: 5px 10px;
    border: none;
    border-radius: 6px;
    margin-top: 6px;
}

.pathwayIcon{
    color: black;
    font-size: 16px;
    margin-top: 3px;
}

@media (max-width: 575px) {
    ::ng-deep .createBadgeModal .mat-dialog-container{
        overflow-x: hidden !important;
    }
}
@media (max-width: 768px) {
    .add-box h5 {
        font-size: 18px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/badges/badges.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,MAAM;AACV;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,uBAAkB;IAAlB,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,aAAa;IACb,cAAc;IACd;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,0CAA0C;AAC9C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;AACA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,WAAW;AACf;;AAEA;;IAEI;gCAC4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,iCAAiC;IACjC,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;;AAGA;IACI,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA;IACI;QACI,6BAA6B;IACjC;AACJ;AACA;IACI;QACI,eAAe;IACnB;AACJ","sourcesContent":[".tab-box-video {\n    width: 100%;\n}\n\n.tab-box-video ul {\n    display: flex;\n    width: 100%;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 4rem;\n}\n\n.tab-box-video ul li {\n    list-style: none;\n    /* font-weight: 500; */\n    font-size: 18px;\n    padding: 5px 0;\n    margin: 0px 25px;\n    color: #878395;\n    cursor: pointer;\n}\n\n.tab-box-video ul li.active {\n    border-top: 3px solid #6c2fbb;\n    color: #6c2fbb;\n}\n\n.library {\n    margin-top: 4rem;\n}\n\n.FF-scroll-modify {\n    /*max-height: 720px;*/\n    /*height: 100%;*/\n    height: 66vh;\n    overflow-x: hidden;\n    overflow-y: scroll;\n    margin-top: 20px;\n}\n.badge-box-container {\n    text-align: center;\n    cursor: pointer;\n}\n\n.add-box {\n    aspect-ratio: 16/9;\n    position: relative;\n    width: 100%;\n    min-height: 200px;\n    height: 100%;\n    border: 2px solid #6c2fbb;;\n    border-radius: 16px;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    cursor: pointer;\n}\n\n.add-box .plus {\n    width: 28px;\n    height: 26px;\n    background: #F8FAFB;\n    border-radius: 4px;\n    text-align: center;\n}\n\n.add-box h5 {\n    color: #6c2fbb;\n}\n.badgeAction {\n    text-align: end;\n    position: absolute;\n    right: 15px;\n    top: 0;\n}\n\n.badge-box .badge-rounded{\n    z-index: 0 !important;\n}\n\n.popup-objective {\n    z-index: 1;\n    position: absolute;\n    background: white;\n    padding: 0 7px;\n    border-radius: 6px;\n    width: fit-content;\n    top: 30px;\n    width: 200px;\n    height: 210px;\n    overflow: auto;\n    left: -66px\n}\n\n.popup-objective ul {\n    text-align: start;\n    padding-left: 25px;\n}\n\n.popup-objective li {\n    margin-top: 10px;\n}\n\n.custom-card {\n    /* background-color: #fff; */\n    width: 100%;\n    height: auto;\n    padding: 6px;\n    /* box-shadow: 0px 0px 10px 0px #dad8d8; */\n}\n\n.custom-card .v-title-edit {\n    display: flex;\n}\n\n.custom-card .v-title-edit .v-title-btn {\n    cursor: pointer;\n    margin: 0;\n    display: none;\n    padding-left: 5px;\n}\n\n.custom-card .v-title-edit:hover .v-title-btn {\n    display: inline-block;\n}\n.v-title-edit:hover .v-title-btn {\n    display: inline-block;\n}\n\n.custom-card .v-title {\n    padding: 2px;\n    cursor: text;\n    font-weight: 500;\n    font-size: 14px;\n    color: #000;\n}\n\n.custom-card p {\n\n    /*font-size: 16px;\n    font-weight:400 !important;*/\n    font-size: 15px;\n    font-weight: 400;\n    width: inherit;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    margin-top: 0;\n    margin-bottom: 0;\n    /*color: rgba(136, 133, 142, 1);*/\n    color: #000;\n}\n\n::ng-deep .createBadgeModal{\n    overflow: auto;\n}\n\n\n.downloadCer{\n    background: #6c2fbbe3;\n    font-size: 15px;\n    color: #ffffff;\n    padding: 5px 10px;\n    border: none;\n    border-radius: 6px;\n    margin-top: 6px;\n}\n\n.pathwayIcon{\n    color: black;\n    font-size: 16px;\n    margin-top: 3px;\n}\n\n@media (max-width: 575px) {\n    ::ng-deep .createBadgeModal .mat-dialog-container{\n        overflow-x: hidden !important;\n    }\n}\n@media (max-width: 768px) {\n    .add-box h5 {\n        font-size: 18px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
